﻿export * from './pager.service';